import {
	createReducer,
	createSlice,
	createAction,
	createAsyncThunk,
	createEntityAdapter,
} from '@reduxjs/toolkit';

import { API } from '../../api';

// export const apiDoClaim = createAsyncThunk(
// 	"claim/doClaim",
// 	async (data, thunkAPI)  => {
// 		let url = `/morty/assistant/claim/${data.requestKey}`;
// 		let payload = { user_key: data.userKey };
// 		const response = await client.post(url, payload);
// 		return response; 
// 	}
// );

export const apiDoClaim = createAsyncThunk(
	"claim/doClaim",
	async (data, thunkAPI)  => {
		let payload = { userKey: data.userKey,
						requestKey: data.requestKey };
		return API.doClaim(payload);
	}
);


// Then, handle actions in your reducers:
const claimSlice = createSlice({
	name: "claim",
	initialState: { claiming: false },
	extraReducers: {
		[apiDoClaim.pending]: (state, action) => {
			state.claiming = true;
		},
		[apiDoClaim.fulfilled]: (state, action) => {
			state.claiming = false;
		},
		[apiDoClaim.rejected]: (state, action) => {
			state.claiming = false;
		}		
	}

});

// export const { apiDoClaim } = claimSlice.actions;
export default claimSlice.reducer; 
